import { Component, OnInit } from '@angular/core';
import { Log } from 'ng2-logger';
import { AdminService } from '../../_services/admin.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';

import 'rxjs/add/operator/mergeMap';
import {ACLFeature} from '../../_models/acl-feature';

const log = Log.create('BatchEditSensors');

@Component({
  templateUrl: 'edit.component.html',
  styleUrls: ['edit.less']
})

export class BatchEditSensorsComponent implements OnInit {

  // family: ModuleFamily = new ModuleFamily('test');
  parentId: number;
  path: string;
  sensorIds: any;
  sensors: any;

  isVisible?: boolean = false;
  isVisibleNa?: boolean = false;
  isVisibleSa?: boolean = false;
  isVisibleCn?: boolean = false;
  isVisibleRoa?: boolean = false;

  isInMaintenanceMode?: boolean = false;
  isInMaintenanceModeNa?: boolean = false;
  isInMaintenanceModeSa?: boolean = false;
  isInMaintenanceModeCn?: boolean = false;
  isInMaintenanceModeRoa?: boolean = false;

  viewStatus?: any;
  viewStatusNa?: any;
  viewStatusSa?: any;
  viewStatusCn?: any;
  viewStatusRoa?: any;

  iCanMaintenanceMode: boolean = false;
  iCanViewArchive: boolean = false;
  iCanArchive: boolean = false;

  sensor_image?: string = null;
  box_quantity?: string = null;
  color?: string = null;
  description?: string = null;

  datasheetUrl?: string = ''; // Database does not allow null for datasheetUrls
  cadfilesUrl?: string = '';
  contactwebsiteUrl?: string = '';
  companywebsiteUrl?: string = '';
  designguideUrl?: string = '';
  productwebsiteUrl?: string = '';

  minHeight: any = 0;
  maxHeight: any = 0;

  toggleVisibility: boolean = false;
  toggleMaintenanceMode: boolean = false;
  toggleSortOrder: boolean = false;
  toggleImages: boolean = false;
  toggleBoxQuantity: boolean = false;
  toggleColour: boolean = false;
  toggleDescription: boolean = false;
  toggleDataSheet: boolean = false;
  toggleUrls: boolean = false;
  toggleSensorHeight: boolean = false;
  toggleSensorAccessory: boolean = false;

  toggleViewStatus: boolean = false;
  toggleViewStatusNa: boolean = false;
  toggleViewStatusSa: boolean = false;
  toggleViewStatusCn: boolean = false;
  toggleViewStatusRoa: boolean = false;

  selectedAccessory: object;
  selectedAccessoryMandatory: boolean = false;
  availableAccessories: Array<any> = [];
  selectedAccessories: Array<any> = [];

  possibleApplications: any;
  applications: Array<any> = [];
  toggleApplications: boolean = false;

  possibleFeatures: any;
  features: Array<any> = [];
  toggleFeatures: boolean = false;

  possibleTechnologies: any;
  technologies: Array<any> = [];
  toggleTechnologies: boolean = false;


  constructor(private admin: AdminService,
              private route: ActivatedRoute,
              private router: Router,
              private toast: ToastsManager) {}

  ngOnInit() {

    log.d('ngOnInit');
    // this.path = (this.route.snapshot.parent.params['type'] === 'modules') ? '/drilldown/modules' : '/drilldown/drivers';
    //
    this.route.params.subscribe((params: any) => {
      log.d(`route /${this.route.snapshot.parent.params['type']}/${params['id']}`, );
      this.sensorIds = params.list.split(',').map( param => parseInt(param) ); // moet een array met getallen worden.
      log.d('sensors recieved from params', this.sensorIds);


      this.admin.getSensorControllers(this.sensorIds).subscribe((data) => {
        log.d('getSensorControllers response', data);
        this.sensors = data.data;

        this.admin.getSensorApplications().subscribe((res) => {
          this.possibleApplications = res.data;
        });

        this.admin.getSensorFeatures().subscribe((res) => {
          this.possibleFeatures = res.data;
        });

        this.admin.getSensorTechnologies().subscribe((res) => {
          this.possibleTechnologies = res.data;
        });
      });
    });

    this.admin.drilldown('sensor-accessories', null).subscribe((response) => {
      this.availableAccessories = response.products.map(accessory => {
        return {
          id: accessory.id,
          text: accessory.name
        };
      });
    });
  }

  // used by checkbox and radio components
  private updateModel(input) {
    this[input.model] = input.updatedData;
  }

  public onSubmit() {
    for (const sensor of this.sensors) {
      if (this.toggleViewStatus) {
        sensor.viewStatus = this.viewStatus;
      }
      if (this.toggleViewStatusNa) {
        sensor.viewStatusNa = this.viewStatusNa;
      }
      if (this.toggleViewStatusSa) {
        sensor.viewStatusSa = this.viewStatusSa;
      }
      if (this.toggleViewStatusCn) {
        sensor.viewStatusCn = this.viewStatusCn;
      }
      if (this.toggleViewStatusRoa) {
        sensor.viewStatusRoa = this.viewStatusRoa;
      }

      if (this.toggleImages) {
        sensor.image = this.sensor_image;
      }
      if (this.toggleDescription) {
        sensor.description = this.description;
      }
      if (this.toggleDataSheet) {
        sensor.datasheetUrl = this.datasheetUrl;
      }
      if (this.toggleUrls) {
        sensor.cadfilesUrl = this.cadfilesUrl;
      }
      if (this.toggleUrls) {
        sensor.contactwebsiteUrl = this.contactwebsiteUrl;
      }
      if (this.toggleUrls) {
        sensor.companywebsiteUrl = this.companywebsiteUrl;
      }
      if (this.toggleUrls) {
        sensor.designguideUrl = this.designguideUrl;
      }
      if (this.toggleUrls) {
        sensor.productwebsiteUrl = this.productwebsiteUrl;
      }
      if (this.toggleApplications) {
        sensor.applications = this.applications;
      }
      if (this.toggleFeatures) {
        sensor.features = this.features;
      }
      if (this.toggleTechnologies) {
        sensor.technologies = this.technologies;
      }
      if (this.toggleSensorHeight) {
        sensor.minHeight = this.minHeight;
        sensor.maxHeight = this.maxHeight;
      }
    }

    log.d('updated sensors', this.sensors);

    this.admin.postSensorControllers(this.sensors).subscribe(data => {
      this.toast.success(`Changes have been saved.`);
      this.router.navigate(['/drilldown/sensors', {refresh: Date.now()}]);
    });
  }

  public onCancel() {
    log.d('onCancel');
    this.router.navigate(['/drilldown/sensors', {refresh: Date.now()}]);
  }

  private addAccessory() {
    if (this.selectedAccessory) {
      let exist = false;
      this.selectedAccessories.forEach(item => {
        if (item.accessory.id === this.selectedAccessory[0].id) {
          exist = true;
          return;
        }
      });

      if (!exist) {
        this.selectedAccessories.push({
          accessory: this.selectedAccessory[0],
          mandatory: this.selectedAccessoryMandatory
        });
        this.selectedAccessoryMandatory = false;
      }
    }
  }

  private removeAccessory(index) {
    this.selectedAccessories.splice(index , 1);
  }
}



// WEBPACK FOOTER //
// ./src/app/batch/sensors/edit.component.ts